module.exports = __webpack_public_path__ + "static/media/Pattern-green.65647db8.svg";